module.exports = "https://cdn.dove.it/_next/static/public/assets/press/logo-wired.8699d9d77f782f00b5e7f3de01b0c45e.png";